/**
 * Bilder und feste Inhalte der Leistungsseiten.
 * images/features sind nach order_index des Services geordnet.
 */
export const SERVICES_KEY = 'page_services';

export const SERVICES_DEFAULTS = {
  "images": {
    "1": "/new_images/AdobeStock_267386573.webp",
    "2": "/new_images/AdobeStock_178589265.webp",
    "3": "/new_images/AdobeStock_302630798.webp",
    "4": "/new_images/AdobeStock_986081604.webp",
    "5": "/new_images/AdobeStock_434989120_Bearbeitung.webp",
    "6": "/new_images/AdobeStock_1082462942.webp",
    "7": "/new_images/AdobeStock_87062828.webp"
  },
  "fallback_image": "/new_images/AdobeStock_219806190.webp",
  "features": {
    "1": {
      "de": [
        "Buchen laufender Geschäftsvorfälle",
        "Kontierung und Erfassung laufender Belege",
        "Buchen von Bank, Kasse, Eingangs- und Ausgangsrechnungen",
        "Monatliche Auswertungen und BWA aus der laufenden Buchhaltung",
        "Kosten- und Leistungsrechnung sowie betriebswirtschaftliche Auswertungen"
      ],
      "en": [
        "Posting of ongoing business transactions",
        "Coding and recording of current documents",
        "Posting of bank, cash, incoming and outgoing invoices",
        "Monthly reports and profit & loss statements",
        "Cost accounting and business management analyses"
      ],
      "ar": [
        "تسجيل المعاملات التجارية الجارية",
        "ترميز وتسجيل المستندات الجارية",
        "تسجيل البنك والصندوق والفواتير الواردة والصادرة",
        "التقارير الشهرية وقوائم الأرباح والخسائر",
        "محاسبة التكاليف والتحليلات الإدارية"
      ]
    },
    "2": {
      "de": [
        "Laufende Lohn- und Gehaltsabrechnung",
        "Fertigen der Lohnsteuer-Anmeldungen",
        "Meldungen an Krankenkassen und Sozialversicherungsträger",
        "Baulohnabrechnung inklusive SOKA-BAU-Meldungen",
        "An- und Abmeldungen sowie Pflege der Mitarbeiterstammdaten",
        "Lohnnachweise, Bescheinigungen und Auswertungen"
      ],
      "en": [
        "Ongoing payroll and salary processing",
        "Preparation of payroll tax returns",
        "Notifications to health insurers and social security bodies",
        "Construction payroll including SOKA-BAU reports",
        "Registration, deregistration and maintenance of employee master data",
        "Pay slips, certificates and evaluations"
      ],
      "ar": [
        "معالجة الرواتب والأجور الجارية",
        "إعداد إقرارات ضريبة الرواتب",
        "الإخطارات لصناديق الصحة وهيئات الضمان الاجتماعي",
        "رواتب قطاع البناء بما في ذلك تقارير SOKA-BAU",
        "تسجيل وإلغاء تسجيل الموظفين وصيانة بياناتهم الأساسية",
        "كشوف الرواتب والشهادات والتقارير"
      ]
    },
    "3": {
      "de": [
        "Analyse Ihrer Unternehmenszahlen",
        "Auswertung von BWA und Kennzahlen",
        "Liquiditätsübersichten und Kostenanalysen",
        "Unterstützung bei Planung und Organisation",
        "Vorbereitung von Unterlagen für Bank oder Behörden",
        "Optimierung kaufmännischer Abläufe und digitaler Prozesse"
      ],
      "en": [
        "Analysis of your business figures",
        "Evaluation of BWA and key metrics",
        "Liquidity overviews and cost analyses",
        "Support with planning and organisation",
        "Preparation of documents for banks or authorities",
        "Optimisation of commercial processes and digital workflows"
      ],
      "ar": [
        "تحليل أرقام شركتك",
        "تقييم BWA والمؤشرات الرئيسية",
        "نظرة عامة على السيولة وتحليلات التكاليف",
        "الدعم في التخطيط والتنظيم",
        "إعداد المستندات للبنوك أو الجهات الحكومية",
        "تحسين العمليات التجارية والعمليات الرقمية"
      ]
    }
  },
  "why_us": {
    "de": [
      "Über 5 Jahre Projekterfahrung",
      "Persönlicher Ansprechpartner",
      "Agile Arbeitsweise",
      "Transparente Kommunikation",
      "Schnelle Umsetzung"
    ],
    "en": [
      "5+ years of project experience",
      "Dedicated contact person",
      "Agile methodology",
      "Transparent communication",
      "Fast delivery"
    ],
    "ar": [
      "أكثر من 5 سنوات خبرة",
      "مسؤول شخصي مخصص",
      "منهجية رشيقة",
      "تواصل شفاف",
      "تسليم سريع"
    ]
  },
  "process": {
    "de": [
      "Erstes Gespräch & Anforderungsanalyse",
      "Konzept & Angebot",
      "Entwicklung & regelmäßige Updates",
      "Übergabe & Support"
    ],
    "en": [
      "Initial call & requirements analysis",
      "Concept & proposal",
      "Development & regular updates",
      "Handover & support"
    ],
    "ar": [
      "مكالمة أولية وتحليل المتطلبات",
      "المفهوم والعرض",
      "التطوير والتحديثات المنتظمة",
      "التسليم والدعم"
    ]
  },
  "texts": {
    "book_appointment": {
      "de": "Termin vereinbaren",
      "en": "Book Appointment",
      "ar": "حجز موعد"
    },
    "included_label": {
      "de": "Leistungsumfang",
      "en": "What's included",
      "ar": "ما يشمله"
    },
    "included_title": {
      "de": "Was wir bieten",
      "en": "What we offer",
      "ar": "ما نقدمه"
    },
    "process_label": {
      "de": "Wie es läuft",
      "en": "How it works",
      "ar": "كيف يعمل"
    },
    "process_title": {
      "de": "Unser Prozess",
      "en": "Our Process",
      "ar": "عمليتنا"
    },
    "why_title": {
      "de": "Warum TOP BHS?",
      "en": "Why TOP BHS?",
      "ar": "لماذا TOP BHS؟"
    },
    "why_text": {
      "de": "Wir stehen für Qualität, Verlässlichkeit und partnerschaftliche Zusammenarbeit. Kontaktiere uns für ein kostenloses Erstgespräch.",
      "en": "We stand for quality, reliability and collaborative partnership. Reach out for a free initial consultation.",
      "ar": "نحن نؤمن بالجودة والموثوقية والشراكة. تواصل معنا للحصول على استشارة أولية مجانية."
    },
    "preferred_date": {
      "de": "Wunschdatum",
      "en": "Preferred Date",
      "ar": "التاريخ المفضل"
    },
    "consultation_for": {
      "de": "Kostenlose Erstberatung für",
      "en": "Free consultation for",
      "ar": "استشارة مجانية لـ"
    },
    "send_request": {
      "de": "Anfrage senden",
      "en": "Send Request",
      "ar": "إرسال الطلب"
    }
  }
};

/** Zusätzliche Angaben je Leistung (nach Service-ID), z. B. ein eigenes Bild */
export const SERVICE_EXTRAS_KEY = 'service_extras';
export type ServiceExtras = Record<string, { image?: string }>;
export const SERVICE_EXTRAS_DEFAULTS: ServiceExtras = {};

/** Bild einer Leistung: eigenes Bild → Bild nach Reihenfolge → Standardbild */
export function serviceImage(
  service: { id: string | number; order_index: number },
  content: typeof SERVICES_DEFAULTS,
  extras: ServiceExtras,
): string {
  return (
    extras[String(service.id)]?.image ||
    (content.images as Record<string, string>)[String(service.order_index)] ||
    content.fallback_image
  );
}

/** Leistungsumfang aus der Datenbank, sonst die Standardliste nach Reihenfolge */
export function serviceFeatures(
  service: { order_index: number; features?: string[] | { de: string[]; en: string[]; ar: string[] } },
  content: typeof SERVICES_DEFAULTS,
): { de: string[]; en: string[]; ar: string[] } {
  const raw = service.features;
  if (Array.isArray(raw) && raw.length > 0) return { de: raw, en: raw, ar: raw };
  if (raw && !Array.isArray(raw) && (raw.de?.length || raw.en?.length || raw.ar?.length)) {
    return { de: raw.de ?? [], en: raw.en ?? [], ar: raw.ar ?? [] };
  }
  const fallback = (content.features as Record<string, { de: string[]; en: string[]; ar: string[] }>)[String(service.order_index)];
  return { de: fallback?.de ?? [], en: fallback?.en ?? [], ar: fallback?.ar ?? [] };
}
